export default "__VITE_ASSET__04aeb30c__"